import { createSlice } from '@reduxjs/toolkit';

// Load group filters from localStorage
const loadGroupFilters = () => {
  try {
    const saved = localStorage.getItem('poiGroupFilters');
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
};

const { reducer, actions } = createSlice({
  name: 'pois',
  initialState: {
    items: {},
    groups: {},
    icons: [],
    groupFilters: loadGroupFilters(), // { groupId: boolean } - true = visible
  },
  reducers: {
    refresh(state, action) {
      state.items = {};
      action.payload.forEach((item) => state.items[item.id] = item);
    },
    update(state, action) {
      action.payload.forEach((item) => state.items[item.id] = item);
    },
    remove(state, action) {
      delete state.items[action.payload];
    },
    refreshGroups(state, action) {
      state.groups = {};
      action.payload.forEach((item) => state.groups[item.id] = item);
    },
    updateGroups(state, action) {
      action.payload.forEach((item) => state.groups[item.id] = item);
    },
    removeGroup(state, action) {
      delete state.groups[action.payload];
    },
    setIcons(state, action) {
      state.icons = action.payload;
    },
    // Group filter actions
    setGroupFilter(state, action) {
      const { groupId, visible } = action.payload;
      state.groupFilters[groupId] = visible;
      localStorage.setItem('poiGroupFilters', JSON.stringify(state.groupFilters));
    },
    toggleGroupFilter(state, action) {
      const groupId = action.payload;
      const current = state.groupFilters[groupId];
      state.groupFilters[groupId] = current === undefined ? false : !current;
      localStorage.setItem('poiGroupFilters', JSON.stringify(state.groupFilters));
    },
    showAllGroups(state) {
      state.groupFilters = {};
      localStorage.setItem('poiGroupFilters', JSON.stringify(state.groupFilters));
    },
    hideAllGroups(state, action) {
      const groupIds = action.payload; // Array of group IDs
      state.groupFilters = {};
      groupIds.forEach((id) => { state.groupFilters[id] = false; });
      state.groupFilters['ungrouped'] = false;
      localStorage.setItem('poiGroupFilters', JSON.stringify(state.groupFilters));
    },
  },
});

export { actions as poisActions };
export { reducer as poisReducer };
